import { WithMultipleValues, BLContext } from './model';
import { AnyUser, ID, MisleadLevel, ConceptType } from '../../../general/model';
import { createAction } from '@reduxjs/toolkit';
import { BLOptions } from '../../../general/modelCreativeFolder';
import { PlotRecognition, PlotRecognitionInfo } from '../../../general/modelPlotRecognition';

export const modalOpened = createAction<void, 'creativeHub/creativeFolder/MODAL_OPENED'>(
  'creativeHub/creativeFolder/MODAL_OPENED',
);
export const editableFieldsUpdated = createAction<
  { fields: (keyof BLOptions)[] },
  'creativeHub/creativeFolder/EDITABLE_FIELDS_UPDATED'
>('creativeHub/creativeFolder/EDITABLE_FIELDS_UPDATED');
export const modalClosed = createAction<void, 'creativeHub/creativeFolder/MODAL_CLOSED'>(
  'creativeHub/creativeFolder/MODAL_CLOSED',
);
export const confirmed = createAction<void, 'creativeHub/creativeFolder/CONFIRMED'>(
  'creativeHub/creativeFolder/CONFIRMED',
);
export const projectSelected = createAction<
  { projectId: ID },
  'creativeHub/creativeFolder/PROJECT_SELECTED'
>('creativeHub/creativeFolder/PROJECT_SELECTED');
export const creativeTypeSelected = createAction<
  { creativeTypeId: ID },
  'creativeHub/creativeFolder/CREATIVE_TYPE_SELECTED'
>('creativeHub/creativeFolder/CREATIVE_TYPE_SELECTED');

export const managerSelected = createAction<
  { managerId: ID; manager: AnyUser | null },
  'creativeHub/creativeFolder/MANAGER_SELECTED'
>('creativeHub/creativeFolder/MANAGER_SELECTED');

export const developerSelected = createAction<
  { developerId: ID; developer: AnyUser | null },
  'creativeHub/creativeFolder/DEVELOPER_SELECTED'
>('creativeHub/creativeFolder/DEVELOPER_SELECTED');

export const teamSelected = createAction<{ teamID: ID }, 'creativeHub/creativeFolder/teamSelected'>(
  'creativeHub/creativeFolder/teamSelected',
);

export const tagsSelected = createAction<
  { tags: string[] },
  'creativeHub/creativeFolder/TAGS_SELECTED'
>('creativeHub/creativeFolder/TAGS_SELECTED');
export const misleadSelected = createAction<
  { option: MisleadLevel['id'] },
  'creativeHub/creativeFolder/mislead selected'
>('creativeHub/creativeFolder/mislead selected');
export const genresSelected = createAction<
  { option: number[] },
  'creativeHub/creativeFolder/genres selected'
>('creativeHub/creativeFolder/genres selected');
export const introSelected = createAction<
  { option: number },
  'creativeHub/creativeFolder/intro selected'
>('creativeHub/creativeFolder/intro selected');
export const aiGeneratedSelected = createAction<
  { option: boolean },
  'creativeHub/creativeFolder/ai generated selected'
>('creativeHub/creativeFolder/ai generated selected');
export const conceptTypeSelected = createAction<
  { option: ConceptType['id'] | null },
  'creativeHub/creativeFolder/concept type selected'
>('creativeHub/creativeFolder/concept type selected');
export const sourceCreativesSelected = createAction<
  { option: { id: number; name: string }[] },
  'creativeHub/creativeFolder/source creatives selected'
>('creativeHub/creativeFolder/source creatives selected');

export const tagSearchTextChanged = createAction<
  { text: string },
  'creativeHub/creativeFolder/TAG_SEARCH_TEXT_CHANGED'
>('creativeHub/creativeFolder/TAG_SEARCH_TEXT_CHANGED');

export const tagsClosed = createAction<void, 'creativeHub/creativeFolder/TAGS_CLOSED'>(
  'creativeHub/creativeFolder/TAGS_CLOSED',
);

export const cancelButtonClicked = createAction<
  void,
  'creativeHub/creativeFolder/CANCEL_BUTTON_CLICKED'
>('creativeHub/creativeFolder/CANCEL_BUTTON_CLICKED');

export const setIsInitialized = createAction<
  { isInitialized: boolean },
  'creativeHub/creativeFolder/SET_IS_INITIALIZED'
>('creativeHub/creativeFolder/SET_IS_INITIALIZED');

export const setConfirmInprogress = createAction<
  { confirmInprogress: boolean },
  'creativeHub/creativeFolder/SET_CONFIRM_INPROGRESS'
>('creativeHub/creativeFolder/SET_CONFIRM_INPROGRESS');

export const modalUpdated = createAction<
  {
    blContext: BLContext;
    preFilled: WithMultipleValues<BLOptions>;
    plotRecognitionInfo: PlotRecognitionInfo | null;
  },
  'creativeHub/creativeFolder/MODAL_UPDATED'
>('creativeHub/creativeFolder/MODAL_UPDATED');

/** Правка полей AI-разметки во вкладке `Metadata` (MYUA-16423). */
export const plotRecognitionChanged = createAction<
  { patch: Partial<PlotRecognition> },
  'creativeHub/creativeFolder/PLOT_RECOGNITION_CHANGED'
>('creativeHub/creativeFolder/PLOT_RECOGNITION_CHANGED');

export const editButtonClicked = createAction<void, 'ch/creativeFolder/EDIT_BUTTON_CLICKED'>(
  'ch/creativeFolder/EDIT_BUTTON_CLICKED',
);
